import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player/lazy';

import Icon from '../Icon';

/**
 * AudioPlayer
 */

class AudioPlayer extends Component {
  constructor(props) {
    super(props);

    /** Parameters */
    this.initialRotation = 0;
    this.play = () => this.setState({ isPlaying: true });
    this.pause = () => this.setState({ isPlaying: false });
    this.paused = () => !this.state.isPlaying;
    this.togglePlayPause = () => this.setState({ isPlaying: !this.state.isPlaying });

    /** State */
    this.state = {
      isPlaying: this.props.play,
      playedSeconds: '',
    };

    /** Refs */
    this.element = React.createRef();
    this.progress = React.createRef();
    this.progressIndicator = React.createRef();
  }

  /**
   * Invoked after the component is mounted
   */
  componentDidMount() {
    /** Get the initial rotation of the progress indicator */
    const progressStyle = window.getComputedStyle(this.progressIndicator.current, null);
    const progressTransform =
      progressStyle.getPropertyValue('-webkit-transform') ||
      progressStyle.getPropertyValue('-moz-transform') ||
      progressStyle.getPropertyValue('-ms-transform') ||
      progressStyle.getPropertyValue('-o-transform') ||
      progressStyle.getPropertyValue('transform');
    let values = progressTransform.split('(')[1];
    values = values.split(')')[0];
    values = values.split(',');
    const angle = Math.round(Math.atan2(values[1], values[0]) * (180 / Math.PI));
    this.initialRotation = angle;
  }

  /**
   *
   * @param {number} played - The progress ratio as a percentage
   * @param {number} playedSeconds - The elapsed play time in seconds, with decimals
   */
  onProgress(played, playedSeconds) {
    const minutes = Math.floor(playedSeconds / 60);
    const seconds = Math.floor(playedSeconds) - minutes * 60;
    this.setState({ playedSeconds: `${minutes}:${seconds < 10 ? '0' : ''}${seconds}` });
    this.progressIndicator.current.style.transform = `rotate(${this.initialRotation + 360 * played}deg)`;
  }

  render() {
    const elementClass = this.props?.className || 'audio-player';
    return (
      <div ref={this.element} className={`${elementClass}`} onClick={() => this.togglePlayPause()}>
        {this.props.legend && <h3 className="audio-player-legend">{this.props.legend}</h3>}
        <div className="audio-player-player">
          <ReactPlayer
            url={this.props.url}
            playing={this.state.isPlaying}
            volume={1}
            light
            playIcon={<Icon icon="play-round" layout="text-white" />}
            onProgress={({ played, playedSeconds }) => this.onProgress(played, playedSeconds)}
            onPlay={() => this.setState({ isPlaying: true })}
            onPause={() => this.setState({ isPlaying: false })}
          />
          {this.state.isPlaying ? (
            <>
              <Icon icon="pause" layout="text-white" />
              <span ref={this.progress} className="audio-player-progress">
                {this.state.playedSeconds}
              </span>
            </>
          ) : (
            <Icon icon="play-round" layout="text-white" />
          )}

          <span ref={this.progressIndicator} className="audio-player-progress-indicator" />
        </div>
      </div>
    );
  }
}

AudioPlayer.propTypes = {
  url: PropTypes.string.isRequired,
  play: PropTypes.bool,
  legend: PropTypes.string,
  className: PropTypes.string,
};

AudioPlayer.defaultProps = {
  play: false,
};

export default AudioPlayer;
